// Configuration résolue au runtime.
//
// En production (conteneur nginx), `public/env-config.js` est régénéré au
// démarrage à partir des variables d'environnement du conteneur
// (voir docker/env-config.sh), ce qui remplit `window._env_`. La config
// REACT_APP_* peut donc être définie dans le docker-compose, comme kiff-api :
// elle n'est plus figée au build.
//
// En dev local (`yarn start`), `window._env_` est vide → on retombe sur les
// valeurs de `.env` inlinées par CRA au build (process.env.REACT_APP_*).
const buildTime = {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_API_WS: process.env.REACT_APP_API_WS,
  REACT_APP_API_KEY: process.env.REACT_APP_API_KEY,
  REACT_APP_API_GOOGLE_MAP: process.env.REACT_APP_API_GOOGLE_MAP,
  REACT_APP_API_VERSION: process.env.REACT_APP_API_VERSION,
  REACT_APP_NAME: process.env.REACT_APP_NAME,
  REACT_APP_MEDIA_URL: process.env.REACT_APP_MEDIA_URL,
};

const runtime = (typeof window !== "undefined" && window._env_) || {};

// Priorité au runtime (window._env_) ; sinon fallback build-time (.env).
const env = (key) => {
  const value = runtime[key];
  return value !== undefined && value !== "" ? value : buildTime[key];
};

export default env;
